module.exports = __webpack_public_path__ + "img/ic24TNDelete.20532418.svg";